<template>
  <div>
    <div class="sku">
      <van-cell :border="false">
        <template slot="title">
          <span class="custom-text">购买须知</span>
        </template>
      </van-cell>
      <div v-for="(item,index) in readlist" :key="index" class="read-item">
        <div class="sy-cell">
          <img :src="item.images" class="icon">
          {{ item.name }}
        </div>
        <div class="read-text">
          {{ item.text }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BuyRead',
  data() {
    return {
      readlist: [
        {
          name: '色差问题',
          text: '由于显示器不同可能产生的色彩偏差以及个人对颜色的理解的不同等因素，实物与图片出现一定程度的色差实属难免，此类问题不属于商品质量问题，所以因为色差问题引起的退换货您需要承担相应的邮费。',
          images: require('../../../assets/images/goods/1.png')
        },
        {
          name: '关于发货',
          text: '收到订单后客服会第一时间安排发货，正常情况下发货后3-5天内送达（地区远近不同，到达天数不同）。',
          images: require('../../../assets/images/goods/2.png')
        },
        {
          name: '发票问题',
          text: '为提高发货效率，默认不提供发票。',
          images: require('../../../assets/images/goods/3.png')
        },
        {
          name: '退换货政策',
          text: '我们承诺自客户收到商品之日起七日内且具备商品收到时完整的原包装、吊牌、赠品等（特别说明，电子类产品一旦开封，非质量问题无法退换货），因质量问题产生的退换货，我们将提供无条件退换货服务。根据法律规定及商品性质，虚拟商品不享受“7天无理由退货”政策。',
          images: require('../../../assets/images/goods/4.png')
        },
        {
          name: '联系客服',
          text: '客服电话：400-880-5555',
          images: require('../../../assets/images/goods/5.png')
        }

      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.sku{
    padding:15px 15px 50px;
    background:#fff;
    .custom-text{
        height:19px;
        font-size:13px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(153,153,153,1);
        line-height:19px;
    }
    .van-cell{
        padding-left:0;
    }
    .sku-text{
        font-size:14px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:20px;
    }
}
.icon{
    width: 18px;
    height: auto;
    margin-right: 4px;
}
.read-text{
margin:10px 0 30px;
font-size:12px;
font-family:PingFangSC-Regular;
font-weight:400;
color:rgba(51,51,51,1);
line-height:16px;
padding-left:26px;
}
</style>
